import { memo } from 'react';

/**
 * `React.memo` erases call-signature generics. This is an explicit typing of
 * `memo` (runtime unchanged) so components with generic props stay generic.
 *
 * @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087#issuecomment-514363457
 */
export const typedMemo: <T>(c: T) => T & { displayName?: string } = memo;
